import Devices from './hardware-management/Devices.vue'
import { routers as DevicesChildrenRouters } from './hardware-management/Devices.js'

import DeviceModels from './hardware-management/DeviceModels.vue'
import { routers as DeviceModelsChildrenRouters } from './hardware-management/DeviceModels.js'

let routers = [
  {
    name: 'devices',
    path: '/legacy-hardware-management/devices',
    component: Devices,
    children: DevicesChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    }
  },
  {
    name: 'device-models',
    path: '/legacy-hardware-management/device-models',
    component: DeviceModels,
    children: DeviceModelsChildrenRouters,
    meta: {
      permissions: ['DEVELOPER_MODE']
    },
  },
  {
    name: 'gateways',
    path: '/legacy-hardware-management/gateways',
    component: Devices,
    meta: {
      permissions: ['DEVELOPER_MODE']
    },
  }
]

export { routers }